import { EventPingActivityTypeEnum, OwnersEnum } from '@goldcast/api/backend';

export const IN_PERSON_ACTIVITY_TYPES: { label: string; value: string }[] = [
  {
    label: 'Registered',
    value: 'REGISTRATION'
  },
  {
    label: 'Attended',
    value: 'ATTENDED'
  },
  {
    label: 'No Show',
    value: 'EVENT_NO_SHOW'
  }
];

export const WAITLIST_ACTIVITY_TYPES: { label: string; value: string }[] = [
  {
    label: 'Waitlisted',
    value: 'WAITLIST'
  },
  {
    label: 'Rejected',
    value: 'REJECTED'
  },
  {
    label: 'Canceled',
    value: 'CANCELED'
  }
];

export const ACTIVITY_TYPES: { label: string; value: string }[] = [
  ...IN_PERSON_ACTIVITY_TYPES,
  {
    label: 'Attended Session',
    value: 'ATTENDED_BROADCAST'
  },
  {
    label: 'Attended Booth',
    value: 'ATTENDED_BOOTH'
  },
  {
    label: 'Attended Discussion Room',
    value: 'ATTENDED_DISCUSSION_GROUP'
  },
  {
    label: 'Resource Downloaded',
    value: 'RESOURCE_DOWNLOAD'
  }
];

export const IN_PERSON_CUSTOM_ACTIVITIES: { activity_name: string; activity_type: string; description: string }[] = [
  {
    activity_name: 'Registered',
    activity_type: 'user_profile:registered',
    description: 'When an event receives a new registrant, a Custom Activity is created.'
  },
  {
    activity_name: 'Attended',
    activity_type: 'user_profile:attended',
    description: 'When an event user attends the event, a Custom Activity representing that Attendence is created.'
  },
  {
    activity_name: 'Event No Show',
    activity_type: 'user_engagement:event_no_show',
    description: 'When an event user did not attend the event'
  },
  {
    activity_name: 'User Profile Updated',
    activity_type: 'user_profile:updated',
    description:
      'When an event user profile updates his profile, a Custom Activity representing that Attendence is created'
  }
];

export const WAITLIST_CUSTOM_ACTIVITIES: { activity_name: string; activity_type: string; description: string }[] = [
  {
    activity_name: 'Waitlisted',
    activity_type: 'user_profile:waitlisted',
    description: 'When a user is waitlisted.'
  },
  {
    activity_name: 'Rejected',
    activity_type: 'user_profile:rejected',
    description: 'When a user is rejected'
  },
  {
    activity_name: 'Canceled',
    activity_type: 'user_profile:canceled',
    description: 'When a user is canceled'
  }
];

export const CUSTOM_ACTIVITIES: { activity_name: string; activity_type: string; description: string }[] = [
  ...IN_PERSON_CUSTOM_ACTIVITIES,
  {
    activity_name: 'Event Poll Response',
    activity_type: 'user_engagement:poll_responses',
    description: 'An event poll has been responded to.'
  },
  {
    activity_name: 'Event Q&A',
    activity_type: 'user_engagement:qna',
    description: 'An event user has asked questions in a broadcast'
  },
  {
    activity_name: 'Event Engagement Score',
    activity_type: 'user_engagement:engagement_score',
    description: 'An event engagement score for the attending event users.'
  },
  {
    activity_name: 'Event Resource Download',
    activity_type: 'user_engagement:resources',
    description: 'An event resource has been downloaded by the event user.'
  },
  {
    activity_name: 'Event Engagement Time',
    activity_type: 'user_engagement:user_timespent_event',
    description: 'The amount of time spent on a finished Goldcast event by an event user .'
  },
  {
    activity_name: 'Event Discussion Rooms Engagement Time',
    activity_type: 'user_engagement:user_timespent_discussion_group',
    description: 'The amount of time spent on a finished Goldcast event discussion rooms by an event user .'
  },
  {
    activity_name: 'Event Booths Engagement Time',
    activity_type: 'user_engagement:user_timespent_booth',
    description: 'The amount of time spent on a finished Goldcast event booths by an event user .'
  },
  {
    activity_name: 'Event Broadcasts Engagement Time',
    activity_type: 'user_engagement:user_timespent_broadcast',
    description: 'The amount of time spent on a finished Goldcast event broadcasts by an event user .'
  },
  {
    activity_name: 'Event CTA Click',
    activity_type: 'user_engagement:event_cta_click',
    description: 'An event CTA button has been clicked in your Goldcast Event by an event user.'
  },
  {
    activity_name: 'Booth CTA Click',
    activity_type: 'user_engagement:booth_cta_click',
    description: 'A booth CTA button has been clicked in your Goldcast Event by an event user.'
  },
  {
    activity_name: 'Attended Session',
    activity_type: 'user_engagement:attended_broadcast',
    description:
      'When an Event User attends a session in the event, an activity representing that Attendance in session is created.'
  },
  {
    activity_name: 'Attended Booth',
    activity_type: 'user_engagement:attended_booth',
    description:
      'When an Event User attends a Booth in the event, an activity representing that Attendance in Booth is created.'
  },
  {
    activity_name: 'Attended Discussion Room',
    activity_type: 'user_engagement:attended_discussion_group',
    description:
      'When an Event User attends a discussion group in the event, an activity representing that Attendance in Discussion Room is created.'
  },
  {
    activity_name: 'In App Survey',
    activity_type: 'user_engagement:in_app_survey',
    description:
      'When an Event User participate in a broadcast and participate in survey, an activity representing In App Survey is created.'
  }
];

export const RECIPIENT_TYPES: { label: string; value: OwnersEnum }[] = [
  { value: 'ACCOUNT_OWNER', label: 'Account Owner' },
  { value: 'CONTACT_OWNER', label: 'Contact Owner' },
  { value: 'LEAD_OWNER', label: 'Lead Owner' }
];

export const TRIGGER_TYPES: { label: string; value: EventPingActivityTypeEnum }[] = [
  { value: 'REGISTRATION', label: 'Event Registration' },
  { value: 'ATTENDED', label: 'Event Attendance' },
  { value: 'PRE_EVENT_REGISTRANT_SUMMARY', label: 'Pre-Event Notification' },
  { value: 'POST_EVENT_ATTENDED_SUMMARY', label: 'Post-Event Attendee Summary' }
];

export const SLACK_FORMATTING_HELP_DOC_URL =
  'https://help.goldcast.io/hc/en-us/articles/23926190210587-Tips-for-Formatting-Your-Custom-Slack-Messages';

export const INTEGRATION_TYPE_MAP = {
  pardot: 'PARDOT',
  slack: 'SLACK',
  'slack-plus-salesforce': 'SLACK_PLUS_SALESFORCE',
  wistia: 'WISTIA',
  webhooks: 'ACTIVITY_WEBHOOK',
  marketo: 'MARKETO',
  salesforce: 'SALESFORCE',
  eloqua: 'ELOQUA',
  hubspot: 'HUBSPOT'
};

export const INTEGRATION_ERROR_PER_PAGE = 10;

export const INTEGRATION_MESSAGE_TIMEOUT = 2000;
